import { userPriv, userInvalid } from "utils/privilege.util";
import { userType, userPrivilege } from "const/nuclias/user";
import { PATH } from "router/config/const";

import store from "stores";

import headerService from "../Headers/service";

export const getNavPriv = () => {
  const { pageContext, user } = store.getState();

  const list = {
    dashboard: {
      root: {
        show: !userInvalid([userType.sp]),
        link: headerService.getHomeUrl(),
      }
    },
    monitor: {
      root: {
        show: !userInvalid([userType.sp]),
      },
    },
    configure: {
      root: {
        show: !userInvalid([userType.sp]) && !userPriv(userPrivilege.editor),
      },
    },
    reports: {
      root: {
        show: !userPriv(userPrivilege.monitor),
      },
      changeLog: {
        show: !userInvalid([userType.sp]),
      },
      summary: {
        show: !userInvalid([userType.sp]),
      },
      alerts: {
        show: !userInvalid([userType.sp]),
      },
      licenses: {
        show: !userInvalid([userType.siteTag, userType.site]),
      },
    },
    settings: {
      root: {
        show: !userPriv(userPrivilege.monitor)
      },
      account: {
        show: !userPriv(userPrivilege.editor),
      },
      org: {
        name: user?.user.type === userType.sp ? '2dbbfa8d0d' : '85827d89ef',
        show: !userPriv(userPrivilege.editor),
      },
      license: {
        show: !userInvalid([userType.sp, userType.siteTag, userType.site]),
      },
      inventory: {
        show: !userInvalid([userType.sp, userType.siteTag, userType.site]),
      },
      firmware: {
        show: !userInvalid([userType.sp]) && !userPriv(userPrivilege.editor),
      },
      alert: {
        show: !userInvalid([userType.sp]),
      },
      certificate: {
        show: !userInvalid([userType.sp]),
      },
      externalAlert: {
        show: userInvalid([userType.si]),
      },
      advanced: {
        show: !userInvalid([userType.sp]) && !userPriv(userPrivilege.editor),
        links: [
          {
            to: PATH.settings.saml_configuration,
            label: '9571c08438',
            disabled: userPriv(userPrivilege.manager),
            show: userInvalid([userType.org]),
          },
          {
            to: '/settings/advanced-settings/sms-configuration',
            label: '4a3188c3ae',
            disabled: false,
            show: true,
          },
          {
            to: '/settings/advanced-settings/syslog-server-configuration',
            label: 'a35df53e36',
            disabled: false,
            show: userInvalid([userType.org]),
          },
        ]
      },
      addDevice: {
        disabled: (userPriv(userPrivilege.manager) || !pageContext.selectedOrg),
        show: !userInvalid([userType.sp]) && !userPriv(userPrivilege.editor),
      },
      bulkDevice: {
        disabled: (userPriv(userPrivilege.manager)),
        show: userInvalid([userType.si, userType.org]) && !userPriv(userPrivilege.editor),
        to: '/settings/bulk-import-devices'
      },
      bulkConfig: {
        show: userInvalid([userType.si]) && !userPriv(userPrivilege.editor),
        links: [
          {
            to: '/settings/bulk-configuration/access-point',
            label: '93f3450afb',
            disabled: userPriv(userPrivilege.manager),
            show: true
          },
          {
            to: '/settings/bulk-configuration/gateway',
            label: '926dec9494',
            disabled: userPriv(userPrivilege.manager),
            show: true
          }
        ]
      }
    },
    help: {
      root: {
        show: !userPriv(userPrivilege.editor),
      },
      technicalSupport: {
        show: !userInvalid([userType.sp]),
      },
      resources: {
        show: !userInvalid([userType.sp]),
      },
      troubleshooting: {
        show: !userInvalid([userType.sp]),
      },
      tutorials: {
        show: !userInvalid([userType.sp]),
      },
    },
  };

  return list;
};